module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAABGdBTUEAALGPC/xhBQAAARZJREFUKBWNkkFLQkEURrWkFMKFFeLORYSbRKRVuAmC/rALF/2ENgW1KESJcFGiRIsIpDrHZqbny6APjnPnztyZO9+zWPhRjbAL+7ANMxjCLXzCioph1mLsgRue4B32YAcmMIAFJG0SedM5zKEP1+BNN6AOoQSPTqI2CGzPmy7gBaI+CC5hBEdQhiQLfZPtZYvSBoL7MNnNJi3UCN/0l+Larxt1TyM8ZJ3qIakHSW7WCN3zrXlVSXRgCiuFumqyAbqnwxpVgQM4hS24gmdwban4HbX7GNrf6fTroXdwAmPQed0uxEJjpQG652hr4p4zaMIYlsW2mpX/jlew4C0s2J7f0mc0wzjKF5Jfq3xx5b+FnhaLNe7hC0IWOqjyUu0UAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic_search.png
// module id = FIF8
// module chunks = 1